const img = document.querySelector('.prop-team .bg-img')

if (img) {
	addEventListener(
		'scroll',
		function () {
			const imgRect = img.getBoundingClientRect()
			const bottomCalc = (imgRect.bottom - window.innerHeight) * -1
			const difference = window.innerHeight - imgRect.height
			const scrollPercent = Math.min(Math.max(bottomCalc / difference, 0), 1)
			img.style.translate = `calc(${scrollPercent} *  (-100% + min(100vw, 100%))`
		},
		{ passive: true }
	)
}
